import { render } from "./SchemaSearch.vue?vue&type=template&id=cc79cbd0&scoped=true"
import script from "./SchemaSearch.vue?vue&type=script&lang=js"
export * from "./SchemaSearch.vue?vue&type=script&lang=js"

import "./SchemaSearch.vue?vue&type=style&index=0&id=cc79cbd0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cc79cbd0"

export default script